import type { SignalsListResponse } from '@logspot-platform/platform-types';
import { api } from './api-client';

type SuccessEnvelope<T> = { data: T };

export type {
  Signal,
  SignalsListResponse,
  SignalType,
  SignalSource,
} from '@logspot-platform/platform-types';

// Filters for the GTM signals feed. All optional; the timeline is just the feed
// scoped to one Target Account via `profileId`. `cursor` is the opaque keyset
// cursor returned as `next_cursor` (null when there's no further page).
export type SignalsListParams = {
  type?: string;
  source?: string;
  acquisitionChannel?: string;
  profileId?: string;
  cursor?: string | null;
  limit?: number;
};

// Org-scoped GTM signals (append-only, evidence-carrying account events). Mirrors
// the backend admin endpoint (api/admin/signals.ts): session auth, `{ data }`
// envelope. See the GTM Signals & Target Accounts PRD.
export const SignalsService = {
  list: async (
    params: SignalsListParams = {},
  ): Promise<SignalsListResponse> => {
    const query = new URLSearchParams();
    if (params.type) query.set('type', params.type);
    if (params.source) query.set('source', params.source);
    if (params.acquisitionChannel)
      query.set('acquisition_channel', params.acquisitionChannel);
    if (params.profileId) query.set('profile_id', params.profileId);
    if (params.cursor) query.set('cursor', params.cursor);
    if (params.limit != null) query.set('limit', String(params.limit));
    const qs = query.toString();
    const r = await api.get<SuccessEnvelope<SignalsListResponse>>(
      `/admin/signals${qs ? `?${qs}` : ''}`,
    );
    return r.data;
  },
};
